import { createContext, Dispatch, SetStateAction } from "react"

export const LoadingContext = createContext<{ loading: boolean; validating: boolean; }>({
    loading: true,
    validating: true
});

export default LoadingContext;